(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.kidReviewReviews = {

    slider: function () {
      $('.field--name-field-kr-reviews').not('.slick-initialized').slick({
        arrows: false,
        centerMode: true,
        dots: true,
        focusOnSelect: true,
        mobileFirst: true,
        infinite: false,
        slidesToShow: 1,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: 'unslick'
          }
        ]
      }).on('afterChange', function (event, slick, direction) {
        dataLayer.push({
          eventCategory: 'kid reviewed',
          eventAction: 'slide',
          eventLabel: 'reviews',
          eventvalue: '',
          event: 'eventSlide'
        });
        // Revalidate on change
        Drupal.blazy.init.revalidate();
      });
    },

    trimReviews: function (element) {
      var $this = $(element);
      var reviewHeight = $this.outerHeight();
      var reviewMax = 180;
      var readMore = '<button class="kr-review__read-more" tabindex="0" aria-label="Press Enter to Toggle Review"><span>Read More</span></button>';

      if (reviewHeight >= reviewMax) {
        $(element).closest('.paragraph-item--kr-review').addClass('kr-review__trimmed');
        $(element).append(readMore);
      }
    },

    readMore: function () {
      $('.kr-review__read-more').on('click touchstart', function (e) {
        $(this).closest('.component-kr-review').toggleClass('component-kr-review--expanded');
      });
    },

    hideMoreReviews: function () {
      $('.component-kr-reviews__container').each(function () {
        var reviews = $(this).find('.field--name-field-kr-review');
        if ($(reviews).length < 7) {
          $(this).parent().find('.component-kr-reviews__cta-container .component-kr-reviews__cta.see-more').hide();
        }
      });
    },

    randomReviewIcons: function () {
      $('.kr-kid-name-age-info-wrapper').each(function () {
        var random = Math.floor((Math.random() * 4) + 1);
        if (random === 1) {
          $(this).addClass('duck');
        }
        else if (random === 2) {
          $(this).addClass('bear');
        }
        else if (random === 3) {
          $(this).addClass('frog');
        }
        else if (random === 4) {
          $(this).addClass('fox');
        }
      });
    },

    attach: function (context, settings) {
      $(once('kidReviewReviews', '.paragraph--type--kr-reviews', context)).each(function () {
        Drupal.behaviors.kidReviewReviews.slider();

        $(this).find('.field--name-field-kr-review p').each(function () {
          Drupal.behaviors.kidReviewReviews.trimReviews($(this));
        });
        Drupal.behaviors.kidReviewReviews.hideMoreReviews();
        Drupal.behaviors.kidReviewReviews.readMore();
        Drupal.behaviors.kidReviewReviews.randomReviewIcons();
        $('.paragraph-item--kr-review:nth-child(n+7)').addClass('js-hidden-initial');

        $('.component-kr-reviews__cta-button').on('click touchstart', function () {
          let $button = $(this);
          let $relatedItems = $button.closest('.component-kr-reviews').find('.paragraph-item--kr-review.js-hidden-initial');
          if ($relatedItems.hasClass('js-hidden-initial')) {
            $relatedItems.show();
            $relatedItems.find('.field--name-field-kr-review p').each(function () {
              Drupal.behaviors.kidReviewReviews.trimReviews($(this));
            });
          }
          Drupal.behaviors.kidReviewReviews.readMore();
          $button.parent().hide();
        });
        window.addEventListener('resize', function () {
          Drupal.behaviors.kidReviewReviews.slider();
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef



